import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Form } from "antd";
import { useState } from "react";
import {
    ContractProduct,
    ContractType,
    DiscountProduct,
    Point,
} from "tm-shared/types";

import { useCatalog } from "@/domains/product";
import BaseButton from "@/shared/ui/BaseButton";
import { ContractFormValues } from "@/types/form";

import { AddProductsModal } from "../AddProductsModal";
import { ContractDiscountRow } from "./ContractDiscountRow";
import { StyledErrorsWrapper } from "./Styled";

interface DiscountProps {
    point: Point | null;
    pointLoading: boolean;
}

export const Discount: React.FC<DiscountProps> = ({ point, pointLoading }) => {
    const { products } = useCatalog();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const form = Form.useFormInstance<ContractFormValues>();

    const menuItems = [
        {
            key: "1",
            label: (
                <Flex gap="5px" align="center">
                    <DeleteOutlined /> Видалити
                </Flex>
            ),
        },
    ];

    return (
        <Flex vertical gap={20} style={{ marginBottom: 24 }}>
            <BaseButton type="primary" onClick={() => setIsModalOpen(true)}>
                Обрати товари
            </BaseButton>

            <Flex vertical gap={12}>
                <Form.List
                    name="discounts"
                    rules={[
                        {
                            validator: async (
                                _,
                                discounts?: ContractProduct[],
                            ) => {
                                const bad = discounts?.some(
                                    ({ price }) => !price || price <= 0,
                                );
                                if (bad)
                                    throw new Error(
                                        "У всіх товарів має бути очікувана вартість",
                                    );
                            },
                        },
                    ]}
                >
                    {(fields, { remove, add }, { errors }) => {
                        const selectedDiscounts: DiscountProduct[] =
                            form.getFieldValue("discounts") || [];
                        return (
                            <>
                                {fields.map((field) => {
                                    const barcode = form.getFieldValue([
                                        "discounts",
                                        field.name,
                                        "barcode",
                                    ]);

                                    return (
                                        <ContractDiscountRow
                                            key={field.key}
                                            productName={
                                                products?.[barcode]?.name ||
                                                "Невідомий товар"
                                            }
                                            field={field}
                                            menuItems={menuItems}
                                            remove={remove}
                                        />
                                    );
                                })}

                                <StyledErrorsWrapper>
                                    <Form.ErrorList errors={errors} />
                                </StyledErrorsWrapper>

                                <AddProductsModal
                                    contractType={ContractType.Discount}
                                    open={isModalOpen}
                                    onClose={() => setIsModalOpen(false)}
                                    selectedProducts={selectedDiscounts}
                                    onAdd={add}
                                    onRemove={(barcode) => {
                                        const index =
                                            selectedDiscounts.findIndex(
                                                (p) => p.barcode === barcode,
                                            );
                                        if (index !== -1) remove(index);
                                    }}
                                    point={point}
                                    pointLoading={pointLoading}
                                />
                            </>
                        );
                    }}
                </Form.List>
            </Flex>
        </Flex>
    );
};
